export default "__VITE_ASSET__8ca7dd1d__"